import awsExport from './aws-exports.js'
import Preorder from './assets/img/preorder.jpg'
import VMS from './assets/img/VMS.png'
import Leads from './assets/img/Leads.jpg'
import Pz1a from './assets/img/Pz1a.jpg'
import Ecommerce from './assets/img/ecommerce.jpg'
import FormulaeTile from './assets/img/formulae-tile.jpg'

export default [
  {
    label: 'V.M.S',
    value: 'V.M.S',
    desc: 'Vehicle Management System',
    url: `${awsExport.aws_content_delivery_url}/admin-console-vms-module/index.html`,
    img: VMS,
    access: 'ADMIN DEALER RBU CRO ADMIN_RBU ADMIN_DEALER',
  },
  {
    label: 'Inventory leads',
    value: 'Leads',
    desc: 'Leads received on New Car Inventories',
    url: `${awsExport.aws_content_delivery_url}/admin-console-leads-module/index.html`,
    img: Leads,
    access: 'ADMIN RBU DEALER',
  },
  {
    label: 'Register your interest',
    value: 'Interest',
    desc: 'Leads received with no online payment',
    url: `${awsExport.aws_content_delivery_url}/admin-console-interest-module/index.html`,
    img: Pz1a,
    access: 'ADMIN RBU CEC',
  },
  {
    label: 'Vehicle Pre-Order',
    value: 'Vehicle Pre-Order',
    desc: 'Back Office',
    url: `${awsExport.aws_content_delivery_url}/admin-console-preorder-module/index.html`,
    img: Preorder,
    access: 'ADMIN RBU CMM CEC',
  },
  {
    label: 'featuresEcomTileTitle',
    value: 'e-commerce',
    desc: 'featuresEcomTileDescription',
    url: `${awsExport.aws_content_delivery_url}/admin-console-ecommerce-module/index.html`,
    img: Ecommerce,
    access: 'ADMIN ECOM CEC RBU',
  },
  {
    label: 'Formula-e',
    value: 'formula-e',
    desc: 'Formula-e',
    url: `${awsExport.aws_content_delivery_url}/admin-console-formulae-module/index.html`,
    img: FormulaeTile,
    access: 'ADMIN',
  },
]
